<template>
  <div>
    <LoadingMask :isLoading="isEditFormLoading" />
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-container v-if="step === 0">
        <v-row>
          <v-col>
            <span class="mainTitle" style="font-size: 20px">Send Message</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ValidationProvider v-slot="{ errors }" name="Message Type" rules="required">
              <v-select
                v-model="model.messageType"
                outlined
                hide-details="auto"
                dense
                label="Choose Message Type"
                :items="clientNotificationMessageTypeOption"
                :error-messages="errors"
              >
              </v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-end">
            <v-btn color="primary" depressed @click="nextStep">
              Next <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-else-if="step === 1" fluid>
        <v-row dense align="center">
          <v-col class="d-flex align-center">
            <span class="mainTitle" style="font-size: 20px">Send Message</span>
          </v-col>
          <v-col class="text-h6">
            {{ model.messageType | translateOptions(clientNotificationMessageTypeOption) }}
          </v-col>
          <v-col cols="auto" class="d-flex">
            <div class="mr-8">
              <div class="subtitle-2 primary--text font-weight-bold">Created By</div>
              <div>{{ get(model, 'created_by.name') }}</div>
            </div>
            <div>
              <div class="subtitle-2 primary--text font-weight-bold">Created Date</div>
              <div>{{ get(model, 'created_at') | moment('YYYY-MM-DD') }}</div>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <ValidationProvider key="patient" v-slot="{ errors }" name="Patient" rules="required">
              <!-- <PatientQuickPicker
                :filter="patientFilter"
                :enableCreate="false"
                title=""
                v-model="model.to"
              >
                <template #header><span></span></template>
              </PatientQuickPicker> -->
            </ValidationProvider>
          </v-col>
          <v-col cols="6" class="d-flex flex-column">
            <div class="primary--text font-weight-bold">Message</div>
            <ValidationProvider v-slot="{ errors }" name="Content" rules="required">
              <v-textarea
                hide-details="auto"
                :no-resize="true"
                outlined
                v-model="model.content"
                :error-messages="errors"
              />
            </ValidationProvider>
            <div v-if="model.to && !isPhoneNumberAvailable" class="mt-auto error--text">
              Not allow to send SMS to this phone number
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-gap">
            <v-btn depressed @click="step--" class="btnTextColor--text"
              ><v-icon>mdi-chevron-left</v-icon> Back
            </v-btn>
            <v-btn depressed @click="cancel" class="btnTextColor--text">Cancel </v-btn>
            <v-btn
              color="#F3E5F5"
              class="btnTextColor--text"
              depressed
              v-if="model.to"
              @click="model.to = null"
            >
              <v-icon>mdi-autorenew</v-icon> re-choose Patient
            </v-btn>
            <v-spacer />
            <v-btn
              class="btnTextColor--text"
              color="#DCEDC8"
              depressed
              :disabled="invalid || !isPhoneNumberAvailable"
              @click="save"
            >
              <v-icon>mdi-content-save</v-icon>
              Save
            </v-btn>
            <v-btn :disabled="!isPhoneNumberAvailable" color="primary" depressed @click="send">
              <v-icon>mdi-send</v-icon>Send</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </ValidationObserver>
  </div>
</template>

<script>
import { clientNotificationStatus, clientNotificationMessageTemplates } from '@/data/constants';
import { clientNotificationMessageTypeOption } from '@/data/optionsConstants';
import { get } from 'lodash';
import moment from 'moment';
import editFormMixin from '@/services/editFormMixin';
import { mapGetters } from 'vuex';
import LoadingMask from '@/components/LoadingMask.vue';
// import PatientQuickPicker from '@/components/Patient/PatientQuickPicker.vue';
import { getOid } from '@/services/utils';
import api from '@/api';
import { ProfileStatus } from '@/api/auth/membership';
import { relatedAccountsPopulate } from '@/api/auth/membership';
import { availableSendSms } from '@/services/rml/notification';

export default {
  components: {
    LoadingMask,
    // PatientQuickPicker,
  },
  mixins: [editFormMixin],
  props: {},
  data() {
    return {
      clientNotificationMessageTypeOption,
      populate: [
        {
          path: 'to',
          populate: [
            relatedAccountsPopulate,
            {
              path: '_lastConsultation',
              select: ['_id', 'date', 'amount', 'hasFollowUp'],
            },
          ],
        },
        {
          path: 'created_by',
          select: ['_id', 'name'],
        },
      ],

      step: -1,
    };
  },
  beforeMount() {
    this.step = this.isCreate && !this.data?._copyFrom ? 0 : 1;
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role']),
    crudURL() {
      //TODO: by role
      return 'rml/admin/clientNotifications';
    },
    maxDate() {
      return moment(this.model.time.end)
        .add(+moment.duration({ d: 1 }))
        .toISOString();
    },
    minDate() {
      return moment(this.model.time.start)
        .add(+moment.duration({ d: 1 }))
        .toISOString();
    },
    patientFilter() {
      const out = {
        status: ProfileStatus.accepted,
      };
      if (this.model.messageType) {
        out['notificationPreference.blockTypes'] = { $ne: this.model.messageType };
      }
      return out;
    },
    isPhoneNumberAvailable() {
      return availableSendSms(this.model?.to?.phone);
    },
  },
  watch: {},
  methods: {
    get,
    defaultData() {
      return {
        via: 'SMS',
        messageType: null,
        status: clientNotificationStatus.Pending,
        created_by: this.profile,
        content: '',
        created_at: moment().toDate(),
      };
    },
    cancel() {
      this.$emit('cancel');
    },
    async save() {
      if (this.isCreate) {
        (await this.promptCreate()) && this.$emit('create');
      } else {
        (await this.promptUpdate()) && this.$emit('update');
      }
    },
    async send() {
      if (!(await this.$refs.form.validate())) {
        return;
      }
      await this.$root.$confirm
        .open('Confirm to Send?', this.model.content, {
          color: 'primary',
          width: '30%',
        })
        .then(async confirm => {
          if (confirm) {
            const model = this.isCreate ? await this.promptCreate() : await this.promptUpdate();
            await this.$store.dispatch('alert/closeAlert');
            (
              await api.post(`/rml/admin/clientNotification/send`, {
                ids: [getOid(model)],
              })
            ).data;
            await this.$store.dispatch('alert/updateAlertMessage', {
              msg: 'Sent',
              type: 'success',
              color: 'success',
            });
            this.$emit('update');
          }
        });
    },
    async nextStep() {
      if (!(await this.$refs.form.validate())) {
        return;
      }
      if (this.isCreate) {
        this.model.content = clientNotificationMessageTemplates[this.model.messageType] || '';
      }
      if (
        (this.model.to?.notificationPreference?.blockTypes || []).includes(this.model.messageType)
      ) {
        this.model.to = null;
      }
      this.step++;
    },
    async afterCreated(model) {
      //this.$emit('create', model);
    },
    async afterUpdated(model) {
      // this.$emit('update', model);
    },
  },
};
</script>

<style lang="scss" scoped></style>
